import { useRef } from 'react';
import { VariableSizeList } from 'react-window';

import { useBreakpoint } from '@/hooks/useBreakpoint';

import {
    ListItemType,
    SecretListId,
    SecurityAuditGroupSize,
    SecurityAuditSecretSize,
    SecurityAuditSecretWithAdditionalSize,
} from '../../constants';
import { useSecretsListOffset } from '../../hooks/useSecretsListOffset';
import type { ListItemSize, SecurityAuditLevelItem } from '../../types';
import { SecurityAuditLevelItemRenderer } from '../SecurityAuditLevelItemRenderer';

export interface SecurityAuditLevelSecretsListProps {
    data: SecurityAuditLevelItem[];
    height: number;
    width: number;
}

export const SecurityAuditLevelSecretsList = ({ data, height, width }: SecurityAuditLevelSecretsListProps) => {
    const listRef = useRef<VariableSizeList<typeof data>>(null);

    const handleOffset = useSecretsListOffset(SecretListId.AUDIT_LEVEL_LIST, listRef);

    const isMin768 = useBreakpoint('sm');

    return (
        <VariableSizeList<typeof data>
            ref={listRef}
            height={height}
            width={width}
            itemData={data}
            itemCount={data.length}
            estimatedItemSize={isMin768 ? SecurityAuditSecretWithAdditionalSize.desktop : SecurityAuditSecretWithAdditionalSize.mobile}
            itemSize={index => {
                const item = data[index];

                let size: ListItemSize = SecurityAuditGroupSize;

                if (item.listItemType === ListItemType.SECRET) {
                    size = item.ignoreSecurityReport ? SecurityAuditSecretWithAdditionalSize : SecurityAuditSecretSize;
                }

                return isMin768 ? size.desktop : size.mobile;
            }}
            itemKey={index => data[index].key}
            onScroll={({ scrollOffset }) => {
                handleOffset(scrollOffset);
            }}
        >
            {/* @ts-expect-error */}
            {SecurityAuditLevelItemRenderer}
        </VariableSizeList>
    );
};
